import createSubmit from '../../Form/createSubmitButton.jsx'
import {name} from './RegisterForm.jsx'

export default createSubmit(name)